"use strict";
import React from "react";
import InlineSVG from "react-inlinesvg";
const SVG = ({ src, className, onLoad }) => {
  if (window.location && window.location.hostname.includes("qwilr-storybook.s3") && src.indexOf("/Assets") === 0) {
    src = `.${src}`;
  }
  if (false) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(InlineSVG, { src, className, onLoad, loader: /* @__PURE__ */ React.createElement("span", { className }) }, /* @__PURE__ */ React.createElement("img", { "aria-hidden": true, className, src }));
};
export default SVG;
